import { defineMessages } from '@approvalmax/utils';

export const messages = defineMessages('components.SplitView.ToggleFullscreen', {
    fullscreen: 'Full screen',
    sideBySide: 'Side-by-side',
});
